export const ARROWS = ['prev', 'next'] as const;

export const TEST_ID_PRICE_CHART_PREVIEW = 'test-id-price-chart-preview';
export const TEST_ID_PRICE_CHART_CONTAINER = 'test-id-price-chart-container';
